import React, { FC, HTMLProps } from 'react';
import ReactModal from 'react-modal';
import cx from 'clsx';

import styles from './styles.module.scss';

// Bind the modal to the root appElement (http://reactcommunity.org/react-modal/accessibility/)
// Check if it exists first so unit tests don't try to bind to root
if (document.getElementById('root')) ReactModal.setAppElement('#root');

export const Spinner: FC<HTMLProps<HTMLDivElement>> = ({ className, ...props }) => (
  <div
    className={cx(styles.wrapper, className)}
    title="Loading"
    {...props}
  />
);

export const OverlaySpinner: FC<HTMLProps<HTMLDivElement>> = props => (
  <ReactModal
    overlayClassName={styles.overlay}
    bodyOpenClassName={styles.noScroll}
    shouldCloseOnEsc={false}
    shouldCloseOnOverlayClick={false}
    isOpen={true}
    className={styles.modal}
  >
    <Spinner {...props} />
  </ReactModal>
);
